import type { ThemeWithoutTokens } from '../theme.types';

export const headerNavSubItemTokens = (theme: ThemeWithoutTokens) =>
  ({
    headerNavSubItemPaddingX: theme.space.component.x.m,
    headerNavSubItemPaddingY: theme.space.component.y.m,
    headerNavSubItemBackgroundColor: theme.colors.body.background,
    headerNavSubItemHoverBackgroundColor: theme.palette.grey100,
  }) as const;
